import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import InputComponent from "components/InputG";
import SelectComponent from "components/SelectG";
import CheckboxComponent from "components/CheckBoxG";
import { InputAdornment, Radio } from "@mui/material";
import { MdKeyboardArrowRight } from "react-icons/md";

import SelectAutoComplete from "components/selectAutoCompleteG";
import RadioComponent from "components/RadioG";
import { useEntradaProcesso } from "services/api/AppWeb_Oportunidade/entrada-processo-put";
import MaterialUI from "material-UI";
import { toast } from "react-toastify";
import { cpf, cnpj } from "cpf-cnpj-validator";
import { useGetCodigoFicha } from "services/api/AppWeb_Oportunidade/get-vincular-ficha";
import { useParams } from "react-router-dom";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { useImobiliarias } from "services/api/AppWeb_Oportunidade/get-imobiliarias";
import { useAutonomos } from "services/api/AppWeb_Oportunidade/get-autonomos";
import { useListarUsuariosCorretoresFifty } from "services/api/Identity_Usuario/listar-corretores-fifty";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

enum R {
  imob = "1",
  aut = "2",
}
/* eslint-disable */
const ModalEntradaProcesso = (data: Data) => {
  const params: any = useParams();
  const { idsBandeiras } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [codigoFicha, setCodigoFicha] = useState(
    data?.dataDetalheOportunidade?.numeroFicha
  );
  const [paymentMethod, setPaymentMethod] = useState("");
  const [checkedClienteMesa, setCheckedClienteMesa] = useState(false);
  const [checkedContratoFisico, setCheckedContratoFisico] = useState(false);
  const [corretorFifty, setCorretorFifty] = useState({ value: "", label: "" });
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [imobAut, setImobAut] = useState<R>(R.imob);
  const { data: dataImob, refetch: refetchImob } = useImobiliarias();
  const { data: dataAut, refetch: refetchAut } = useAutonomos();
  const [cia, setCia] = useState({
    _: { value: "", label: "" },
    doc: "",
    nome: "",
    numeroCreci: "",
    email: "",
  });

  const { usuarioCia, usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  useEffect(() => {
    if (usuarioCia) {
      refetchImob();
      refetchAut();
    }
  }, []);

  const dataImobMap = dataImob?.imobiliarias?.map((item: any) => ({
    value: item.id,
    label: item.nome,
    apelido: item.apelido,
    cnpj: item.cnpj,
    email: item.email,
    creci: item.creci,
  }));

  const dataAutMap = dataAut?.autonomos?.map((item: any) => ({
    value: item.id,
    label: item.nomeCompleto,
    cpf: item.cnpj,
    email: item.email,
    creci: item.creci,
  }));

  const { data: dataCorretores, refetch: refetchCorretores } =
    useListarUsuariosCorretoresFifty({
      queryKey: "listar-corretores-equipe-entrada",
      idsBandeiras: idsBandeiras || [],
    });

  const convertFormaPagamentoValue = (value: number | undefined) => {
    switch (value) {
      case 100000001:
        // Se 100000001 equivale a "Boleto"
        return "2";
      case 100000002:
        return "1";
      default:
        return "100000000"; // ou algum valor padrão
    }
  };

  const convertFormaPagamentoNome = (nome: string | undefined | null) => {
    const normalizado = (nome || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();

    if (normalizado.includes("pix")) return "1";
    if (normalizado.includes("boleto")) return "2";
    if (normalizado.includes("ted")) return "3";
    if (normalizado.includes("cheque")) return "4";
    return "";
  };

  // Quando a forma de pagamento já vem definida do backend, o modal exibe
  // apenas o texto (sem os radios), então o valor é derivado daqui
  const formaPagamentoDefinida =
    Boolean(data?.dataDetalheOportunidade?.repasseAssociativo) ||
    data?.dataDetalheOportunidade?.formaPagamentoNome != null;

  const paymentMethodDefinido = !formaPagamentoDefinida
    ? ""
    : data?.dataDetalheOportunidade?.formaPagamentoValue
    ? convertFormaPagamentoValue(
        data.dataDetalheOportunidade.formaPagamentoValue
      )
    : convertFormaPagamentoNome(
        data?.dataDetalheOportunidade?.formaPagamentoNome
      );

  const paymentMethodEfetivo = paymentMethodDefinido || paymentMethod;

  const {
    mutate: mutateEntradaProcesso,
    isSuccess: isSuccessEntradaProcesso,
    isLoading: isLoadingEntradaProcesso,
  } = useEntradaProcesso({
    idLeadCorretor: params?.idLeadCorretor,
    idCorretorLead: data.dataDetalheOportunidade?.idCorretor365,
    idOportunidade: data.dataDetalheOportunidade?.idOportunidade,
    idCorretorFifty: corretorFifty?.value,
    clienteNaMesa: checkedClienteMesa,
    contratoFisico: checkedContratoFisico,
    tipoPagamento: paymentMethodEfetivo,
    cpfCnpj,
    numeroFicha: codigoFicha,
    nomeCorretorFifty: corretorFifty?.label,
    nomeImobiliaria: cia?.nome,
    numeroCreci: cia?.numeroCreci,
    email: cia?.email,
    cnpj: cia?.doc,
    cpf: cia?.doc,
    nomeAutonomo: cia?.nome,
    // Só envia imobiliaria ou autonomo se houver seleção (cia._.value não vazio)
    autonomo: usuarioCia && cia?._?.value ? imobAut === R.aut : undefined,
    imobiliaria: usuarioCia && cia?._?.value ? imobAut === R.imob : undefined,
  });

  const {
    data: dataFicha,
    refetch: refetchCodigoFicha,
    status: statusFicha,
    isFetching: isFetchingCodigoFicha,
  } = useGetCodigoFicha({
    codigoFicha,
    idUnidade:
      data?.dataDetalheOportunidade?.idUnidade ||
      data?.dataDetalheOportunidade?.unidadeId,
    idLeadCorretor:
      data?.dataDetalheOportunidade?.idLeadCorretor ||
      data?.dataDetalheOportunidade?.idLeadCorretor365 ||
      params?.idLeadCorretor,
  });

  useEffect(() => {
    if (statusFicha === "success" && dataFicha?.cpf) {
      setCpfCnpj(formatCpfCnpj(dataFicha.cpf));
    } else {
      setCpfCnpj("");
    }
  }, [statusFicha, dataFicha]);

  useEffect(() => {
    if (data?.dataDetalheOportunidade?.cpfCnpj) {
      setCpfCnpj(formatCpfCnpj(data.dataDetalheOportunidade.cpfCnpj));
    }
  }, [data?.dataDetalheOportunidade?.cpfCnpj]);

  useEffect(() => {
    if (
      codigoFicha === "" ||
      (dataFicha?.codigoFicha &&
        codigoFicha !== dataFicha?.codigoFicha.toString())
    ) {
      setCpfCnpj("");
    }
  }, [codigoFicha, dataFicha]);

  const disableCpf = () => {
    // Se statusFicha === "success" e dataFicha possui CPF, o campo fica desabilitado.
    return statusFicha === "success" && Boolean(dataFicha?.cpf);
  };

  const isValidCpfCnpj = (value: string) => {
    const digits = value.replace(/\D/g, "");

    if (digits.length === 11) {
      return cpf.isValid(digits);
    }

    if (digits.length === 14) {
      return cnpj.isValid(digits);
    }

    return false;
  };

  const isValidPartnerDoc = (value: string) => {
    const digits = value.replace(/\D/g, "");

    return imobAut === R.imob ? cnpj.isValid(digits) : cpf.isValid(digits);
  };

  useEffect(() => {
    if (dataCorretores?.data === undefined) {
      refetchCorretores();
    }
  }, []);

  useEffect(() => {
    if (isSuccessEntradaProcesso) {
      data.refetchDetalheOportunidade();
      data.refetchHistorico();
      data.onClose();
    }
  }, [isSuccessEntradaProcesso]);

  const verifyFields = () => {
    if (codigoFicha === "" || cpfCnpj === "" || paymentMethodEfetivo === "") {
      toast.error("Preencha todos os campos obrigatórios");
      return true;
    }

    if (!isValidCpfCnpj(cpfCnpj)) {
      toast.error("CPF/CNPJ inválido");
      return true;
    }

    if (usuarioCia) {
      if (
        cia.doc === "" ||
        cia.nome === "" ||
        cia.numeroCreci === "" ||
        cia.email === ""
      ) {
        toast.error("Preencha todos os campos obrigatórios");
        return true;
      }

      if (!isValidPartnerDoc(cia.doc)) {
        toast.error(imobAut === R.imob ? "CNPJ inválido" : "CPF inválido");
        return true;
      }
    }
    return false;
  };

  const handleSubmit = () => {
    if (verifyFields()) {
      return;
    }
    mutateEntradaProcesso();
  };

  const handleCodigoFicha = () => {
    refetchCodigoFicha();
  };

  /**
   * 1. Remove todos os caracteres não numéricos e formata o valor para CPF ou CNPJ
   *    em tempo real (evento onChange).
   */
  const handleCpfCnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    // Remove tudo que não for dígito
    value = value.replace(/\D/g, "").slice(0, 14);

    if (value.length <= 11) {
      // Aplica máscara CPF: XXX.XXX.XXX-XX
      value = value
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2");
    } else {
      // Aplica máscara CNPJ: XX.XXX.XXX/XXXX-XX
      value = value
        .replace(/(\d{2})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1/$2")
        .replace(/(\d{4})(\d{1,2})/, "$1-$2");
    }

    setCpfCnpj(value);
  };

  const formatCpfCnpj = (value: string) => {
    const cleanedValue = value.replace(/\D/g, "");

    if (cleanedValue.length <= 11) {
      // Aplica máscara CPF: XXX.XXX.XXX-XX
      return cleanedValue
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})/, "$1-$2");
    }
    // Aplica máscara CNPJ: XX.XXX.XXX/XXXX-XX
    return cleanedValue
      .replace(/(\d{2})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1/$2")
      .replace(/(\d{4})(\d{1,2})/, "$1-$2");
  };

  const handleCpfCnpjBlur = () => {
    const digits = cpfCnpj.replace(/\D/g, "");
    if (digits.length !== 11 && digits.length !== 14) {
      setCpfCnpj("");
    } else if (!isValidCpfCnpj(cpfCnpj)) {
      toast.error("CPF/CNPJ inválido");
    }
  };

  const handleDocChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;

    // Remove tudo que não for dígito
    value = value.replace(/\D/g, "");

    // Se for imobiliária, assume CNPJ
    if (imobAut === R.imob) {
      // Limita a 14 dígitos
      value = value.slice(0, 14);

      // XX.XXX.XXX/XXXX-XX
      if (value.length > 2) {
        value = value.replace(/^(\d{2})(\d)/, "$1.$2");
      }
      if (value.length > 6) {
        value = value.replace(/^(\d{2}\.\d{3})(\d)/, "$1.$2");
      }
      if (value.length > 10) {
        value = value.replace(/^(\d{2}\.\d{3}\.\d{3})(\d)/, "$1/$2");
      }
      if (value.length > 15) {
        value = value.replace(/^(\d{2}\.\d{3}\.\d{3}\/\d{4})(\d{2})$/, "$1-$2");
      }
    } else {
      // Caso contrário, assume CPF
      // Limita a 11 dígitos
      value = value.slice(0, 11);

      // XXX.XXX.XXX-XX
      if (value.length > 3) {
        value = value.replace(/^(\d{3})(\d)/, "$1.$2");
      }
      if (value.length > 7) {
        value = value.replace(/^(\d{3}\.\d{3})(\d)/, "$1.$2");
      }
      if (value.length > 11) {
        value = value.replace(/^(\d{3}\.\d{3}\.\d{3})(\d)/, "$1-$2");
      }
    }

    setCia((prev) => ({ ...prev, doc: value }));
  };

  /**
   * Exemplo de validação simples ao sair do campo.
   * Se não tiver 11 dígitos (CPF) ou 14 dígitos (CNPJ) no total, limpa o campo.
   */
  const handleDocBlur = () => {
    const digits = cia.doc.replace(/\D/g, "");
    if (imobAut === R.imob && digits.length !== 14) {
      setCia((prev) => ({ ...prev, doc: "" }));
    } else if (imobAut === R.aut && digits.length !== 11) {
      setCia((prev) => ({ ...prev, doc: "" }));
    } else if (!isValidPartnerDoc(cia.doc)) {
      toast.error(imobAut === R.imob ? "CNPJ inválido" : "CPF inválido");
    }
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <S.TextTitle>Entrada de Processo</S.TextTitle>
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={20} />
      <S.Body>
        <S.TextCodigoFicha>Código Ficha *</S.TextCodigoFicha>
        <S.SpaceY space={4} />
        <S.TextField
          InputLabelProps={{ shrink: false }}
          variant="outlined"
          fullWidth
          disabled={data?.dataDetalheOportunidade?.numeroFicha !== null}
          type="number"
          onChange={(e) => setCodigoFicha(e.target.value)}
          value={
            data?.dataDetalheOportunidade?.numeroFicha
              ? data?.dataDetalheOportunidade?.numeroFicha
              : codigoFicha
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ paddingRight: 0 }}>
                <S.ButtonVincular
                  onClick={() => {
                    handleCodigoFicha();
                  }}
                  disabled={data?.dataDetalheOportunidade?.numeroFicha !== null}
                >
                  {isFetchingCodigoFicha ? (
                    <MaterialUI.CircularProgress
                      size={16}
                      style={{ color: "#ffffff" }}
                    />
                  ) : (
                    "Vincular"
                  )}
                </S.ButtonVincular>
              </InputAdornment>
            ),
          }}
        />
        <S.SpaceY space={20} />
        <InputComponent
          onChange={handleCpfCnpjChange}
          value={
            data?.dataDetalheOportunidade?.cpfCnpj
              ? formatCpfCnpj(data?.dataDetalheOportunidade?.cpfCnpj)
              : statusFicha === "success" && dataFicha?.cpf
              ? formatCpfCnpj(dataFicha.cpf)
              : cpfCnpj
          }
          onBlur={handleCpfCnpjBlur}
          disabled={
            disableCpf() || data?.dataDetalheOportunidade?.cpfCnpj !== null
          }
          type="text"
          label="CPF/CNPJ *"
          width="100%"
          borderRadius="8px"
        />
        <S.SpaceY space={20} />
        {usuarioCia ? (
          <>
            <S.TextPagamentoSinal>
              Imobiliária ou autônomo?
            </S.TextPagamentoSinal>
            <S.SpaceY space={10} />
            <S.Row style={{ gap: 8 }}>
              <S.Row>
                <RadioComponent
                  value={R.imob}
                  label="Imobiliária"
                  checked={imobAut === R.imob}
                  onChange={(e) => {
                    setImobAut(e.target.value as R);
                    setCia((prev) => ({
                      ...prev,
                      _: { value: "", label: "" },
                      doc: "",
                    }));
                  }}
                />
                <RadioComponent
                  value={R.aut}
                  label="Autônomo"
                  checked={imobAut === R.aut}
                  onChange={(e) => {
                    setImobAut(e.target.value as R);
                    setCia((prev) => ({
                      ...prev,
                      _: { value: "", label: "" },
                      doc: "",
                    }));
                  }}
                />
              </S.Row>
            </S.Row>
            <S.SpaceY space={20} />
            <S.Row style={{ gap: 20 }}>
              <SelectAutoComplete
                data={imobAut === R.imob ? dataImobMap || [] : dataAutMap || []}
                placeholder="Selecione"
                label={imobAut === R.imob ? "Imobiliária *" : "Autônomo *"}
                borderRadius="8px"
                value={cia._}
                onChange={(e: { value: string; label: string }) => {
                  setCia((prev) => ({ ...prev, _: e }));
                }}
              />
              <InputComponent
                onChange={handleDocChange}
                onBlur={handleDocBlur}
                value={cia.doc}
                type="text"
                label={imobAut === R.imob ? "CNPJ *" : "CPF *"}
                placeholder={`Digite o ${
                  imobAut === R.imob ? "CNPJ da Imobiliária" : "CPF do Autônomo"
                }`}
                width="100%"
                borderRadius="8px"
              />
            </S.Row>
            <S.SpaceY space={10} />
            <S.Row style={{ gap: 20 }}>
              <InputComponent
                onChange={(e) => {
                  setCia((prev) => ({ ...prev, nome: e.target.value }));
                }}
                value={cia.nome}
                label={`Nome ${
                  imobAut === R.imob ? "da Imobiliária" : "do Autônomo"
                } *`}
                placeholder={`Digite o nome ${
                  imobAut === R.imob ? "da Imobiliária" : "do Autônomo"
                }`}
                width="100%"
                borderRadius="8px"
              />
              <InputComponent
                onChange={(e) => {
                  setCia((prev) => ({ ...prev, numeroCreci: e.target.value }));
                }}
                value={cia.numeroCreci}
                type="number"
                label="Número do CRECI *"
                placeholder="Digite o número do CRECI"
                width="100%"
                borderRadius="8px"
              />
            </S.Row>
            <S.SpaceY space={20} />
            <InputComponent
              onChange={(e) => {
                setCia((prev) => ({ ...prev, email: e.target.value }));
              }}
              value={cia.email}
              label={`Email ${
                imobAut === R.imob ? "Imobiliária" : "Autônomo"
              } *`}
              placeholder={`Digite o email ${
                imobAut === R.imob ? "da Imobiliária" : "do Autônomo"
              }`}
              width="100%"
              borderRadius="8px"
            />
            <S.SpaceY space={20} />
          </>
        ) : null}
        <InputComponent
          onChange={() => {}}
          value={data?.dataDetalheOportunidade?.nomeCorretor}
          disabled
          label="Corretor"
          width="100%"
          borderRadius="8px"
        />
        <S.SpaceY space={20} />
        <SelectAutoComplete
          data={
            dataCorretores?.data.map((item: any) => ({
              value: item?.idCorretor,
              label: item?.apelido,
            })) || []
          }
          label="Corretor Fifty"
          borderRadius="8px"
          value={corretorFifty}
          onChange={(e: { value: string; label: string }) => {
            setCorretorFifty(e);
          }}
        />
        <S.SpaceY space={5} />
        {!usuarioVivaz ? (
          <>
            <CheckboxComponent
              label="Contrato Físico"
              checked={checkedContratoFisico}
              onChange={() => setCheckedContratoFisico(!checkedContratoFisico)}
              color="#2D5BFF"
            />
          </>
        ) : null}
        <CheckboxComponent
          label="Cliente na mesa"
          checked={checkedClienteMesa}
          onChange={() => setCheckedClienteMesa(!checkedClienteMesa)}
          color="#2D5BFF"
        />
        <S.SpaceY space={10} />
        <S.TextPagamentoSinal>
          Pagamento de parcela sinal via * :
        </S.TextPagamentoSinal>
        <S.SpaceY space={10} />
        {paymentMethodDefinido ? (
          <S.TextPagamentoSinal>
            {data?.dataDetalheOportunidade?.formaPagamentoNome}
          </S.TextPagamentoSinal>
        ) : (
          <>
            <S.Row style={{ gap: 8 }}>
              <S.Row>
                <RadioComponent
                  value={"1"}
                  label="Pix"
                  checked={paymentMethod === "1"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <RadioComponent
                  value="2"
                  label="Boleto"
                  checked={paymentMethod === "2"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <RadioComponent
                  value="3"
                  label="Ted"
                  checked={paymentMethod === "3"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <RadioComponent
                  value="4"
                  label="Cheque"
                  checked={paymentMethod === "4"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
              </S.Row>
            </S.Row>
          </>
        )}
      </S.Body>
      <S.SpaceY space={20} />
      <S.Row style={{ gap: 16 }}>
        <S.CancelButton onClick={data.onClose}>Cancelar</S.CancelButton>
        <S.SendButton
          disabled={isLoadingEntradaProcesso}
          onClick={handleSubmit}
          style={{ gap: 8 }}
        >
          {isLoadingEntradaProcesso ? (
            <MaterialUI.CircularProgress
              size={22}
              style={{ color: "#ffffff" }}
            />
          ) : (
            "Dar entrada no processo"
          )}
          <MdKeyboardArrowRight size={22} color="#FFFFFF" />
        </S.SendButton>
      </S.Row>
    </S.Content>
  );
};

export default ModalEntradaProcesso;
